import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../components/DashboardLayout/DasboardLayout";
import { MessageSquare, Clock, User, Search } from "lucide-react";
import { API_URL } from "../components/config";

const CustomerServiceHome = () => {
  const [chats, setChats] = useState([]);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const adminId = localStorage.getItem("adminId");

  useEffect(() => {
    if (adminId) {
      fetchChatsByAdmin(adminId);
    }
  }, [adminId]);

  const fetchChatsByAdmin = async (adminId) => {
    try {
      const response = await axios.get(
        `${API_URL}/clientservicechat/admin/${adminId}`
      );
      setChats(response.data);
      setError(null);
    } catch (err) {
      console.error("Error fetching chats for admin:", err);
      setError("Failed to fetch chats for this admin.");
    }
  };

  const handleChatClick = (chatId, customer_id) => {
    navigate(`/CustomerServiceChat/${chatId}/${customer_id}`);
  };

  const filteredChats = chats.filter(
    (chat) =>
      chat.client_service_chat_id.toString().includes(searchTerm) ||
      chat.customer_id.toString().includes(searchTerm)
  );

  return (
    <DashboardLayout>
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="bg-white rounded-2xl shadow-lg p-6">
            {/* Header */}
            <div className="flex justify-between items-center mb-8">
              <div>
                <h1 className="text-3xl font-bold text-[#002966]">
                  Customer Service
                </h1>
                <p className="text-gray-600 mt-1">
                  Manage your customer conversations
                </p>
              </div>
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search chats..."
                  className="pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ffc000] focus:border-transparent"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Search
                  className="absolute left-3 top-2.5 text-gray-400"
                  size={20}
                />
              </div>
            </div>

            {error && (
              <div className="bg-red-50 text-red-600 p-4 rounded-lg mb-6">
                {error}
              </div>
            )}

            {/* Chat List */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredChats.length > 0 ? (
                filteredChats.map((chat) => (
                  <div
                    key={chat.client_service_chat_id}
                    className="bg-white border border-gray-100 rounded-xl p-6 cursor-pointer hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
                    onClick={() =>
                      handleChatClick(
                        chat.client_service_chat_id,
                        chat.customer_id
                      )
                    }
                  >
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 rounded-full bg-[#ffc000] flex items-center justify-center">
                          <User className="text-[#002966]" size={20} />
                        </div>
                        <div>
                          <h2 className="text-lg font-semibold text-[#002966]">
                            Customer #{chat.customer_id}
                          </h2>
                          <span className="text-sm text-gray-500">
                            Chat #{chat.client_service_chat_id}
                          </span>
                        </div>
                      </div>
                      <div className="h-3 w-3 bg-green-400 rounded-full"></div>
                    </div>

                    <div className="space-y-3">
                      <div className="flex items-center text-gray-600">
                        <MessageSquare size={16} className="mr-2" />
                        <span className="text-sm">Active Conversation</span>
                      </div>
                      <div className="flex items-center text-gray-600">
                        <Clock size={16} className="mr-2" />
                        <span className="text-sm">
                          {new Date(chat.date_created).toLocaleDateString(
                            "en-US",
                            {
                              month: "short",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            }
                          )}
                        </span>
                      </div>
                    </div>

                    <div className="mt-4 pt-4 border-t border-gray-100">
                      <button
                        className="w-full bg-[#002966] text-white py-2 rounded-lg hover:bg-[#001f4d] transition-colors duration-300"
                        onClick={() =>
                          handleChatClick(
                            chat.client_service_chat_id,
                            chat.customer_id
                          )
                        }
                      >
                        View Conversation
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-span-full text-center py-10">
                  <MessageSquare
                    size={48}
                    className="mx-auto text-gray-400 mb-4"
                  />
                  <p className="text-gray-600 text-lg">
                    No active chats available
                  </p>
                  <p className="text-gray-400">
                    New conversations will appear here
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CustomerServiceHome;
